import React from 'react';
import Slider from 'react-slick';
import '../styles/Home.css';

const Home = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <section id="home" className="home">
      <div className="slider-container">
          <div>
            <img src="carousel.png" alt="Slide 1" className="slider-image" />
          </div>
      </div>
      <h1>Merigold Care</h1>
      <p className='title'>You don’t need more noise. You need alignment.</p>
      <p className='text'><strong>Merigold Care</strong> is created for people who are building— careers, businesses, lives; but want to do it with clarity, not chaos.
        <br></br>This isn’t about quick fixes or surface-level motivation.
        <br></br>It’s about the work beneath: the habits, the mindset, the quiet decisions, that shape everything.</p>
        <p className='title'>Not just products. A guided system.
        <br></br>Discover your best self. Start your journey today. 
        </p>
      <button onClick={() => document.getElementById('products').scrollIntoView()}>See Products</button>
      {/* <img src="home.png" alt="Header" className="section-image" /> */}
    </section>
  );
};

export default Home;
